import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Drawer } from 'antd';

import _, { isString } from 'lodash';
import { isEmpty, isNotEmpty } from 'util/utils';
import { useForm } from 'util/hooks';
import IntlMessages from 'util/IntlMessages';
import UtilService from 'services/util';
import { trackTypeObj, LOCAL_STORAGE_VAR, KYC_STATUS } from 'constants/Common';
import { StoneService } from 'services/StoneService';
import ConfirmStonePopup from './ConfirmStonePopup';
import QuotePopup from './QuotePopup';
import FinalCalculations from './FinalCalculations';
import ShareDropdown from './ShareDropdown';
import DownloadDropdown from './DownloadDropdown';
import BidPopup from './BidPopup';
import MobileShareOption from './MobileShareOption';
import MobileDownloadOption from './MobileDownloadOption';
import OfficeSidebar from './OfficeSidebar';
import StatusBlock from '../StatusBlock';
import Pagination from '../Pagination';
import Reminder from '../Reminder';
import UpdateReminder from '../UpdateReminder';
import CommonModal from '../CommonModal';

import {
  handleInsertTrack,
  compareStones,
  LISTINGPAGES,
  handlePrint,
  handleTrackDelete,
  handleUpsertTrack,
  handleDownloadExcel,
  myAccountExcelTrack,
  myAccountExcelMemo,
  myAccountExcelOffice,
  myAccountPrintTrack,
  myAccountPrintMemo,
  myAccountPrintOffice,
  handlePrintTrack,
  handleDownloadExcelTrack,
  getPath,
  isMobile,
  handleDeleteOffice,
} from '../../DiamondList/DiamondListFunctions';
import OpenNotification from '../CommonButton/OpenNotification';
import { Field, Input, Label } from '../Input/Input';

const DiamondListingAction = (props) => {
  const [visible, setVisible] = useState('');
  const [moreSearch, moreSearchOption] = useState(false);
  const [more, setMore] = useState(false);
  const [permission, setPermission] = useState({});
  const [reminder, setReminder] = useState(false);
  const [excelPopup, setExcelPopup] = useState(false);
  const [disclaimer, setDisclaimer] = useState(false);
  const [alertMessage, setAlertMessage] = useState('This functionality is currently disabled.');

  const { values, handleChange } = useForm(
    {
      sheetName: '',
    },
    {
      transform: {
        sheetName: (value) => (isString(value) ? value.trim() : ''),
      },
    },
  );

  const selectedRows = useSelector((state) => state.diamondData.selectedRows[props.currentType]);
  const checked = React.useMemo(() => {
    return selectedRows ?? props.checkedData ?? [];
  }, [props.checkedData, selectedRows]);

  const isMobileView = isMobile();

  useEffect(() => {
    const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);

    if (props.permKey) {
      const permission = props.commonData.pagePermission()[props.permKey];
      setPermission({ ...permission });
    } else {
      const perm = {
        all: true,
        delete: true,
        downloadExcel: true,
        insert: true,
        mailExcel: true,
        printPDF: true,
        update: true,
        uploadExcel: true,
        view: true,
      };
      setPermission({ ...perm });
    }
    const userTypeCheck = userData?.type === 4 || userData?.type === 10;
    void (isEmpty(userData)
      ? setAlertMessage('Register yourself to access the functionality.')
      : userTypeCheck && !userData?.account?.isKycUploaded
      ? setAlertMessage('Please complete your KYC procedure to access the functionality.')
      : userTypeCheck && userData?.account?.isApproved === KYC_STATUS.PENDING
      ? setAlertMessage('Please wait to access the functionality untill your KYC documents get verify.')
      : userTypeCheck && userData?.account?.isApproved === KYC_STATUS.REJECT
      ? setAlertMessage('Your KYC is rejected. Please upload your KYC again with right information')
      : null);
  }, [props.commonData, props.permKey]);

  const moreSearchDrawer = () => {
    moreSearchOption(true);
  };

  const onClose = () => {
    setVisible('');
    setReminder('');
    moreSearchOption(false);
  };

  const path = window.location.pathname.split('/')[1];
  const module = window.location.pathname.split('/')[2];
  const mobile = window.innerWidth <= 991;

  const actions = React.useMemo(() => {
    return [
      !props.bidStone
        ? null
        : {
            name: <IntlMessages id="app.bidStone" />,
            key: 'bid',
            onClick: () =>
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to bid.' })
                : !permission.insert
                ? OpenNotification({ type: 'error', title: alertMessage })
                : setVisible('bid'),
          },
      !props.myBid
        ? null
        : {
            name: <IntlMessages id="app.myBid" />,
            key: 'mybid',
            img: require('../../../assets/svg/DiamondList/my-bid.svg'),
            onClick: () => {
              // if (!isGuest) {
              props.history.push('/my-bid');
              // } else {
              //   setShowGuest(true);
              // }
            },
          },
      props.updateBid
        ? {
            name: <IntlMessages id="app.updateStone" />,
            //img: require('../../../assets/svg/DiamondList/updatestone.svg'),
            key: 'update',
            onClick: () => {
              // if (!isGuest) {
              if (getPath() === LISTINGPAGES.REMINDER) {
                isEmpty(checked)
                  ? OpenNotification({
                      type: 'error',
                      title: 'Please select stone(s) to update reminder.',
                    })
                  : setReminder('update');
              } else if (
                getPath() === LISTINGPAGES.MYBID ||
                getPath() === LISTINGPAGES.MYDEALOFDAYLIST ||
                getPath() === LISTINGPAGES.DEALOFDAYLIST
              ) {
                isEmpty(checked)
                  ? OpenNotification({
                      type: 'error',
                      title: 'Please select stone(s) to update bid.',
                    })
                  : setVisible('bid');
              } else if (getPath() === LISTINGPAGES.NOTE) {
                isEmpty(checked)
                  ? OpenNotification({
                      type: 'error',
                      title: 'Please select stone(s) to update note.',
                    })
                  : setVisible('note');
              }
            },
            //  else {
            //   setShowGuest(true);
            // }
            // },
          }
        : null,
      props.noconfirm
        ? null
        : {
            name: <IntlMessages id="app.BuyNow" />,
            key: 'confirm',
            onClick: () => {
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to confirm.' })
                : !permission.insert
                ? OpenNotification({ type: 'error', title: alertMessage })
                : checked.some((a) => ['H', 'M'].includes(a.wSts))
                ? OpenNotification({
                    type: 'error',
                    title: 'Sorry! Unable to perform action at this time. The selected diamond(s) is in Hold/Memo.',
                  })
                : checked.map((d) => d.sStsDesc).includes('GIA Result')
                ? setDisclaimer(true)
                : setVisible('confirm');
            },
            img: require('assets/svg/DiamondSearch/confirm.svg'),
          },
      props.nocart
        ? null
        : {
            name: <IntlMessages id="app.Cart" />,
            key: 'cart',
            onClick: () =>
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to add in cart.' })
                : !permission.insert
                ? OpenNotification({ type: 'error', title: alertMessage })
                : handleInsertTrack(trackTypeObj.CART, checked, () => props.clearAll()),
            img: require('assets/svg/DiamondList/cart.svg'),
          },
      props.nowatch
        ? null
        : {
            name: <IntlMessages id="app.Watch" />,
            key: 'watch',
            onClick: () =>
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to add in watch.' })
                : !permission.insert
                ? OpenNotification({ type: 'error', title: alertMessage })
                : handleInsertTrack(trackTypeObj.WATCHLIST, checked, () => props.clearAll()),
            img: require('assets/svg/DiamondList/watch.svg'),
          },
      props.noquote
        ? null
        : {
            name: <IntlMessages id="app.Offer" />,
            key: 'quote',
            onClick: () =>
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(s) to apply offer.' })
                : !permission.insert
                ? OpenNotification({ type: 'error', title: alertMessage })
                : checked.find((stone) => stone?.wSts === 'M' || stone?.wSts === 'H')
                ? OpenNotification({ type: 'error', title: 'You can not apply Offer on Hold/Memo Stone.' })
                : checked.find((stone) => stone?.wSts === 'D')
                ? OpenNotification({ type: 'error', title: 'You can not apply Offer on Best Buy Stone.' })
                : checked.find((stnCrt) => stnCrt?.crt >= 4)
                ? OpenNotification({
                    type: 'error',
                    title: 'You can not Apply Offer on greater than 4.00 Carat Stone.',
                  })
                : checked.find((stn) => stn?.crt < 0.89) && checked?.length < 25
                ? OpenNotification({
                    type: 'error',
                    title: 'You have to add at least 25 stones for less than 0.89 Carat (Dossier). ',
                  })
                : setVisible('quote'),
          },
      // props.nooffice
      //   ? null
      //   : {
      //       name: <IntlMessages id="app.Office" />,
      //       key: 'office',
      //       onClick: () =>
      //         isEmpty(checked)
      //           ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to add in office.' })
      //           : !permission.insert
      //           ? OpenNotification({ type: 'error', title: alertMessage })
      //           : checked.find((stone) => ['H', 'M'].includes(stone?.wSts))
      //           ? OpenNotification({ type: 'error', title: 'You can not apply Office Request on Hold/Memo Stone.' })
      //           : setVisible('office'),
      //     },
      !(props.noExportExcel || props.data.length <= 0)
        ? {
            name: 'Excel',
            key: 'exportExcel',
            onClick: () => {
              if (!permission.downloadExcel) {
                OpenNotification({ type: 'error', title: alertMessage });
              } else {
                setExcelPopup(true);
              }
            },
          }
        : null,

      props.order
        ? null
        : props.nocompare
        ? {
            name: (
              <span>
                <IntlMessages id="app.CompareStoneNow" />
                {' (' + props.data.length + ')'}
              </span>
            ),
            key: 'compare',
            onClick: () => {
              if (!permission.insert) {
                OpenNotification({ type: 'error', title: alertMessage });
              } else {
                localStorage.setItem(`${LOCAL_STORAGE_VAR}-more`, true);
                props.history.push(JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-now`)));
              }
            },
          }
        : {
            name: <IntlMessages id="app.compare" />,
            key: 'compare',
            img: require('assets/svg/DiamondList/compare.svg'),
            onClick: () => {
              if (!permission.insert) {
                OpenNotification({ type: 'error', title: alertMessage });
              } else {
                compareStones(checked);
                props.clearAll();
              }
            },
          },
      !props.noshare
        ? {
            name: <IntlMessages id="app.Share" />,
            key: 'share',
            onClick: () =>
              !permission.mailExcel ? OpenNotification({ type: 'error', title: alertMessage }) : setVisible('share'),
          }
        : null,
      !props.nodownload
        ? {
            name: <IntlMessages id="app.Download" />,
            key: 'download',
            onClick: () => {
              if (!permission.downloadExcel) {
                OpenNotification({ type: 'error', title: alertMessage });
              } else {
                isEmpty(checked)
                  ? OpenNotification({ type: 'error', title: 'Please select diamond(s).' })
                  : setVisible('download');
              }
            },
          }
        : null,
      !props.noprint
        ? {
            name: <IntlMessages id="app.PrintList" />,
            key: 'print',
            onClick: () => {
              if (!permission.printPDF) {
                OpenNotification({ type: 'error', title: alertMessage });
              } else {
                if (path === 'account') {
                  if (checked.length > 0) {
                    if (module === 'confirm-list' || module === 'my-purchase') {
                      handlePrintTrack(
                        {},
                        checked.map((chk) => chk.diamondId), // memoDetail.diamondId
                        props.printType,
                        () => {},
                      );
                    } else {
                      handlePrint(
                        {},
                        checked.map((chk) => chk.id),
                        props.printType,
                        () => {},
                      );
                    }
                  } else {
                    if (module === 'watchlist') {
                      myAccountPrintTrack(2);
                    } else if (module === 'cart') {
                      myAccountPrintTrack(1);
                    } else if (module === 'quote-list') {
                      myAccountPrintTrack(4);
                    } else if (module === 'confirm-list') {
                      myAccountPrintMemo({ status: 1 });
                    } else if (module === 'my-purchase') {
                      myAccountPrintMemo({ status: 2 });
                    } else if (module === 'office-list') {
                      myAccountPrintOffice();
                    }
                  }
                } else {
                  if (path === 'compare') {
                    handlePrint(
                      {},
                      props.data.map((chk) => chk.id),
                      props.printType,
                      () => {},
                    );
                  } else {
                    handlePrint(
                      getPath() === LISTINGPAGES.STONE_OF_DAY
                        ? { wSts: ['D'] }
                        : getPath() === LISTINGPAGES.NEWARR
                        ? { viewType: 2 }
                        : props.seachFilterTag
                        ? props.seachFilterTag.searchData
                        : {},
                      checked.map((chk) => chk.id),
                      props.printType,
                      () => {},
                    );
                  }
                }
                props.clearAll();
              }
            },
          }
        : null,
      props.update
        ? {
            name: <IntlMessages id="app.Update" />,
            key: 'update',
            onClick: () =>
              isEmpty(checked)
                ? OpenNotification({ type: 'error', title: 'Please select stone(stones) to update reminder.' })
                : permission.update
                ? setReminder('update')
                : OpenNotification({ type: 'error', title: alertMessage }),
          }
        : null,
      props.delete
        ? {
            name: <IntlMessages id="app.Delete" />,
            key: 'delete',
            onClick: () => {
              if (isEmpty(checked)) {
                return OpenNotification({ type: 'error', title: 'Please select stone(s) to delete.' });
              }
              if (getPath() === LISTINGPAGES.OFFICE) {
                const schedule = [];
                checked.map((ck) => {
                  schedule.push({
                    diamonds: [ck.id],
                    id: ck.slottId,
                  });
                  return true;
                });

                handleDeleteOffice({ schedule: schedule }, () => {
                  props.clearAll();
                  props.fetch();
                  OpenNotification({ type: 'success', title: 'Your stone(s) is removed from office successfully.' });
                });
              } else {
                handleTrackDelete(props.trackType, _.map(checked, 'id'), props.inTrackDiamonds, () => {
                  props.fetch();
                  props.clearAll();
                });
              }
            },
          }
        : null,
      props.shipment ? { name: 'Shipment', key: 'shipment' } : null,
    ].filter(isNotEmpty);
  }, [
    alertMessage,
    checked,
    module,
    path,
    permission.downloadExcel,
    permission.insert,
    permission.mailExcel,
    permission.printPDF,
    permission.update,
    props,
  ]);

  return (
    <>
      <div className="mobileSearchBottom">
        {actions.slice(0, 3).map((x, i) => {
          return (
            <div className="mobileSearchActionItem" key={i}>
              <a onClick={x.onClick}>
                <img alt="" src={x.img} />
                <span>{x.name}</span>
              </a>
            </div>
          );
        })}
        <div className="mobileSearchActionItem">
          <a onClick={moreSearchDrawer}>
            <img alt="" src={require('assets/svg/DiamondSearch/more.svg')} />
            <span>More</span>
          </a>
        </div>
      </div>
      {moreSearch && (
        <Drawer onClose={onClose} visible={moreSearch} wrapClassName="mobileSidebar mobileBottomSidebar" destroyOnClose>
          <div className="MoreSearchOptionItem">
            <ul>
              {actions.slice(3, actions.length).map((x, i) => {
                return (
                  <li onClick={x.onClick} key={i}>
                    <a>{x.name}</a>
                  </li>
                );
              })}
            </ul>
          </div>
        </Drawer>
      )}
      <div
        className={
          'botoomStickyBar diamondListingAction' + (props.ActionFalse === false ? ' justify-content-center' : '')
        }
      >
        <div className="d-flex listingAction">
          {actions.slice(0, mobile ? 3 : 6).map((x, i) => {
            return (
              <a key={i} className="bottomStickyButton" onClick={x.onClick}>
                <span>{x.name}</span>
              </a>
            );
          })}
          {((mobile && actions.length > 3) || actions.length > 6) && (
            <Dropdown isOpen={more} onClick={() => setMore(!more)}>
              <DropdownToggle className="bottomStickyButton" caret>
                <span>
                  <IntlMessages id="app.More" />
                </span>
              </DropdownToggle>

              <DropdownMenu className="diamondListBottomDropdown">
                <ul>
                  {actions.slice(mobile ? 3 : 6, actions.length).map((x, i) => {
                    return (
                      <li key={i} onClick={x.onClick}>
                        <a>
                          <div className="dropdownBottomItem">
                            <span>{x.name}</span>
                          </div>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </DropdownMenu>
            </Dropdown>
          )}
        </div>

        {!props.nopaginate && <Pagination {...props} />}
      </div>
      {disclaimer && (
        <CommonModal
          visible={disclaimer}
          handleOk={() => {
            setDisclaimer(false);
            setVisible('confirm');
          }}
          handleCancel={() => {
            setDisclaimer(false);
            props.clearAll();
          }}
          title="Disclaimer"
          modalSize="xs-size"
          submitTitle="Continue"
          cancelTitle="Cancel"
          footerShow
        >
          <div>
            <p>
              Please take note that your confirming a stone that is on Result delivery time may take anything from 2
              Days to 15 days.
            </p>
          </div>
        </CommonModal>
      )}

      <Drawer
        visible={visible === 'confirm'}
        onClose={onClose}
        wrapClassName="diamondListinSidebar offerPopup"
        destroyOnClose
      >
        {visible === 'confirm' && <ConfirmStonePopup {...props} checked={checked} onClose={onClose} />}
      </Drawer>

      {(visible === 'quote' || props.editOffer) && (
        <Drawer
          onClose={() => {
            onClose();
            if (props.editOffer) props.fetch();
          }}
          visible={visible === 'quote' || props.editOffer}
          wrapClassName="diamondListinSidebar offerPopup"
          destroyOnClose
        >
          <QuotePopup
            {...props}
            checked={checked}
            onClose={() => {
              onClose();
              void props.clearAll?.();
              if (props.editOffer) props.fetch();
            }}
          />
        </Drawer>
      )}
      <Drawer
        onClose={onClose}
        visible={visible === 'bid'}
        wrapClassName="diamondListinSidebar offerPopup"
        destroyOnClose
      >
        {visible === 'bid' && <BidPopup checked={checked} {...props} onClose={onClose} />}
      </Drawer>
      <Drawer
        onClose={onClose}
        visible={visible === 'office'}
        wrapClassName="diamondListinSidebar offerPopup"
        destroyOnClose
      >
        {visible === 'office' && <OfficeSidebar {...props} checked={checked} onClose={onClose} />}
      </Drawer>
      <Drawer onClose={onClose} visible={visible === 'finalCalc'} wrapClassName="diamondListinSidebar" destroyOnClose>
        {visible === 'finalCalc' && <FinalCalculations {...props} checked={checked} onClose={onClose} />}
      </Drawer>
      {visible === 'share' && isMobileView === false && (
        <CommonModal
          modalSize="xs-size"
          title="Share Stone"
          handleCancel={onClose}
          visible={true}
          wrapClassName=""
          destroyOnClose
        >
          <ShareDropdown
            {...props}
            filter={props.seachFilterTag ? props.seachFilterTag.searchData : {}}
            checked={checked}
            onCloseSharePopup={onClose}
          />
        </CommonModal>
      )}
      <Drawer
        onClose={onClose}
        visible={visible === 'share' && isMobileView}
        wrapClassName="diamondListinSidebar xl-size"
        destroyOnClose
      >
        {visible === 'share' && isMobileView && <MobileShareOption {...props} checked={checked} onClose={onClose} />}
      </Drawer>
      {visible === 'download' && isMobileView === false && (
        <CommonModal
          modalSize="ListingModal"
          title={<IntlMessages id="app.Download" />}
          handleCancel={onClose}
          visible={true}
        >
          <DownloadDropdown
            fromList={props.fromList}
            filter={props.seachFilterTag ? props.seachFilterTag.searchData : {}}
            {...props}
            checked={checked}
            onCloseDownloadPopup={onClose}
          />
        </CommonModal>
      )}
      <Drawer
        onClose={onClose}
        visible={visible === 'download' && isMobileView}
        wrapClassName="diamondListinSidebar xl-size"
        destroyOnClose
      >
        {visible === 'download' && isMobileView && (
          <MobileDownloadOption
            fromList={props.fromList}
            filter={props.seachFilterTag ? props.seachFilterTag.searchData : {}}
            {...props}
            checked={checked}
            onCloseDownloadPopup={onClose}
          />
        )}
      </Drawer>
      <Drawer onClose={onClose} visible={reminder === 'insert'} wrapClassName="diamondListinSidebar" destroyOnClose>
        {reminder === 'insert' && (
          <Reminder
            handleCancel={() => {
              setReminder(false);
              props.clearAll();
            }}
            checked={checked}
            handleSetReminder={(e) =>
              handleInsertTrack(
                trackTypeObj.REMINDER,
                checked,
                () => {
                  props.clearAll();
                  setReminder(false);
                },
                e,
              )
            }
          />
        )}
      </Drawer>
      <Drawer onClose={onClose} visible={reminder === 'update'} wrapClassName="diamondListinSidebar" destroyOnClose>
        {reminder === 'update' && (
          <UpdateReminder
            checked={checked}
            handleCancel={() => {
              setReminder(false);
              props.clearAll();
            }}
            date={checked[0] ? checked[0].reminderDate : null}
            handleUpdateReminder={(e) =>
              handleUpsertTrack(
                trackTypeObj.REMINDER,
                checked,
                props.inTrackDiamonds,
                () => {
                  props.clearAll();
                  props.fetch();
                  setReminder(false);
                },
                e,
              )
            }
          />
        )}
      </Drawer>
      {excelPopup && (
        <CommonModal
          title={'Export Excel'}
          modalSize="xs-size"
          visible={excelPopup}
          handleCancel={() => setExcelPopup(false)}
          footerShow
        >
          <div className="searchPopupCommon">
            <Field>
              <Label for="sheetName">File Name</Label>
              <Input name="sheetName" placeholder="Enter File Name" value={values.sheetName} onChange={handleChange} />
            </Field>
            <div className="shareOptionSet d-flex">
              <div className="shareOptionSetItem">
                <ul>
                  <li
                    onClick={() => {
                      if (path === 'account') {
                        if (checked.length > 0) {
                          if (module === 'confirm-list' || module === 'my-purchase') {
                            handleDownloadExcelTrack(
                              true,
                              {},
                              checked.map((chk) => chk.diamondId), ////memoDetail.diamondId
                              () => {},
                              values?.sheetName,
                            );
                          } else {
                            StoneService.exportAsExcel({
                              sheetName: values?.sheetName || undefined,
                              summary: true,
                              list: checked,
                            });
                            handleDownloadExcel(
                              true,
                              {},
                              checked.map((chk) => chk.id),
                              () => {},
                              values?.sheetName,
                            );
                          }
                        } else {
                          if (module === 'watchlist') {
                            myAccountExcelTrack(true, 2);
                          } else if (module === 'cart') {
                            myAccountExcelTrack(true, 1);
                          } else if (module === 'quote-list') {
                            myAccountExcelTrack(true, 4);
                          } else if (module === 'confirm-list') {
                            myAccountExcelMemo(true, { status: 1 });
                          } else if (module === 'my-purchase') {
                            myAccountExcelMemo(true, { status: 2 });
                          } else if (module === 'office-list') {
                            myAccountExcelOffice(true);
                          }
                        }
                      } else {
                        if (path === 'compare') {
                          // StoneService.exportAsExcel({
                          //   sheetName: values?.sheetName || undefined,
                          //   summary: true,
                          //   list: checked,
                          // });
                          handleDownloadExcel(
                            true,
                            {},
                            props.data.map((chk) => chk.id),
                            () => {},
                            values?.sheetName,
                          );
                        } else {
                          handleDownloadExcel(
                            true,
                            getPath() === LISTINGPAGES.STONE_OF_DAY
                              ? { wSts: ['D'] }
                              : getPath() === LISTINGPAGES.NEWARR
                              ? { viewType: 2 }
                              : props.seachFilterTag
                              ? props.seachFilterTag.searchData
                              : {},
                            checked.map((chk) => chk.id),
                            () => {},
                            values?.sheetName,
                          );
                        }
                      }
                      setExcelPopup(false);
                    }}
                    className="active"
                  >
                    <div className="dropdownBottomItem">
                      <span className="shareOptionLabel">With Summary</span>
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      if (path === 'account') {
                        if (checked.length > 0) {
                          if (module === 'confirm-list' || module === 'my-purchase') {
                            handleDownloadExcelTrack(
                              false,
                              {},
                              checked.map((chk) => chk.diamondId), //memoDetail.diamondId
                              () => {},
                              values?.sheetName,
                            );
                          } else {
                            // StoneService.exportAsExcel({
                            //   sheetName: values?.sheetName || undefined,
                            //   summary: false,
                            //   list: checked,
                            // });

                            handleDownloadExcel(
                              false,
                              {},
                              checked.map((chk) => chk.id),
                              () => {},
                              values?.sheetName,
                            );
                          }
                        } else {
                          if (module === 'watchlist') {
                            myAccountExcelTrack(false, 2);
                          } else if (module === 'cart') {
                            myAccountExcelTrack(false, 1);
                          } else if (module === 'quote-list') {
                            myAccountExcelTrack(false, 4);
                          } else if (module === 'confirm-list') {
                            myAccountExcelMemo(false, { status: 1 });
                          } else if (module === 'my-purchase') {
                            myAccountExcelMemo(false, { status: 2 });
                          } else if (module === 'office-list') {
                            myAccountExcelOffice(false);
                          }
                        }
                      } else {
                        if (path === 'compare') {
                          // StoneService.exportAsExcel({
                          //   sheetName: values?.sheetName || undefined,
                          //   summary: false,
                          //   list: checked,
                          // });
                          handleDownloadExcel(
                            false,
                            {},
                            props.data.map((chk) => chk.id),
                            () => {},
                            values?.sheetName,
                          );
                        } else {
                          handleDownloadExcel(
                            false,
                            getPath() === LISTINGPAGES.STONE_OF_DAY
                              ? { wSts: ['D'] }
                              : getPath() === LISTINGPAGES.NEWARR
                              ? { viewType: 2 }
                              : props.seachFilterTag
                              ? props.seachFilterTag.searchData
                              : {},
                            checked.map((chk) => chk.id),
                            () => {},
                            values?.sheetName,
                          );
                        }
                      }
                      setExcelPopup(false);
                    }}
                    className="active"
                  >
                    <div className="dropdownBottomItem">
                      <span className="shareOptionLabel">Without Summary</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};

export default connect((props) => {
  return { commonData: props.commonData };
}, {})(DiamondListingAction);
